export default __webpack_public_path__ + "static/media/93.5520d527.png";